import { useEffect } from 'react'
import DeviseLanguage from '@legacy/common/components/DeviseLanguage'
import { SchoolLogoColor } from '@legacy/common/types/whitelabel'
import Logo from '@legacy/components/shared/Logo/logo-component'
import { Mosaico } from '@legacy/pages/Account/SignIn/session-new-styles'
import { NotificationProvider } from 'context'
import { BodyForgotPasswordScreen } from './BodyForgotPasswordScreen'
import { Space, Heading } from 'components'
import { useTranslation } from 'react-i18next'
import { Container } from '@mantine/core'
import { Flex } from 'components/Flex'
import { useMediaQuery } from '@mantine/hooks'
import { LayoutLogin } from 'components'
import { ArcAuthHeader } from 'components/ArcAuthHeader'
import { ArcAuthShell } from 'components/ArcAuthPage'
import { ArcForgotColumn } from './arcStyles'
import { useSpecificFeature } from 'hooks'


export const ForgotPasswordScreen = () => {
  const { t, i18n } = useTranslation()
  const isMobile = useMediaQuery('(max-width: 600px)')
  // Flipper endpoint: works unauthenticated, unlike the global features context (AR-792)
  const { enabled: arcNewProjectEnabled, loading: isFlagLoading } =
    useSpecificFeature('arc-mosaico-project')

  // Arc: forçar idioma inglês
  useEffect(() => {
    if (arcNewProjectEnabled) {
      i18n.changeLanguage('en')
    }
  }, [arcNewProjectEnabled, i18n])

  // Hold rendering until the flag resolves so neither branding flashes, and
  // until English is applied so the copy doesn't flash in another language (AR-792)
  if (isFlagLoading) return null
  if (arcNewProjectEnabled && i18n.language !== 'en') return null

  const content = (
    <>
      <Space h='xl' />
      <Container size='54rem' px={isMobile ? 20 : 0}>
        <Flex justify='center'>
          <Heading
            size='xl'
            text={t('forgot_password.forgot_password_title')}
            supportText={t('forgot_password.forgot_password_subtitle')}
          />
        </Flex>
      </Container>
      <BodyForgotPasswordScreen />
    </>
  )

  return (
    <NotificationProvider>
      <LayoutLogin>
        {arcNewProjectEnabled ? (
          <ArcAuthShell>
            <ArcAuthHeader />
            <ArcForgotColumn>{content}</ArcForgotColumn>
          </ArcAuthShell>
        ) : (
          <>
            <Mosaico>
              <Logo color={SchoolLogoColor.White} />
              <DeviseLanguage />
            </Mosaico>
            {content}
          </>
        )}
      </LayoutLogin>
    </NotificationProvider>
  )
}
